import style from "./SideMenu.css";
import { mainCategories } from "../static-data";

const SideMenu = (props) => {
  const { onCategorySelect, selectedCategory } = props;
  const renderMenuItemStyle = (key) =>
    selectedCategory === key
      ? style.selectedVendorMapSearchMenuItem
      : style.vendorMapSearchMenuItem;

  return (
    <div class={style.vendorSearchMenu}>
      {mainCategories.map((category) => (
        <a
          key={category.key}
          href="#"
          class={renderMenuItemStyle(category.key)}
          onClick={() => onCategorySelect(category.key)}
        >
          <img class={style.vendorMapSearchMenuImage} src={category.iconUrl} />
          <span class={style.vendorMapSearchMenuTitle}>{category.title}</span>
        </a>
      ))}
    </div>
  );
};

export { SideMenu };
